import { ENV } from '@/config/env';
import { USER_ROLES } from '@/constants';

export const canEditOwnCompany = ({
  userRoleId,
  userCompanyId,
  currentCompanyId,
}: {
  userRoleId?: number;
  userCompanyId?: number;
  currentCompanyId?: number;
}) => {
  // Guard against undefined company IDs - both must be present
  if (userCompanyId === undefined || currentCompanyId === undefined) {
    return false;
  }

  const isOwnCompany = userCompanyId === currentCompanyId;

  return userRoleId === USER_ROLES.GENERAL_ADMIN_ID && isOwnCompany;
};

export const editCompanyUrls = {
  services: `${ENV.APRO_URL}/new_administration/services`,
  locations: `${ENV.APRO_URL}/new_administration/locations`,
  providers: `${ENV.APRO_URL}/new_administration/service_providers`,
  company: `${ENV.APRO_URL}/company_settings`,
};

export const canReplyReviews = ({
  userRoleId,
  userCompanyId,
  currentCompanyId,
}: {
  userRoleId?: number;
  userCompanyId?: number;
  currentCompanyId?: number;
}) => {
  if (!userCompanyId || !currentCompanyId) {
    return false;
  }

  const isOwnCompany = userCompanyId === currentCompanyId;

  return (userRoleId === USER_ROLES.GENERAL_ADMIN_ID || userRoleId === USER_ROLES.LOCATION_ADMIN_ID) && isOwnCompany;
};
